import script from "./MylistOrders.vue?vue&type=script&setup=true&lang=ts"
export * from "./MylistOrders.vue?vue&type=script&setup=true&lang=ts"

import "./MylistOrders.vue?vue&type=style&index=0&id=8f0cd43a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f0cd43a"]])

export default __exports__